import types from './types';

const defaultState = {
  unNumberList: [],
  isLoading: false
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.GET_UN_NUMBER_LIST:
      return { ...state, isLoading: true };
    case types.GET_UN_NUMBER_LIST_SUCCESS:
      return { ...state, unNumberList: data, isLoading: false };
    case types.GET_UN_NUMBER_LIST_FAILURE:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};
